module.exports = __webpack_public_path__ + "static/media/Bas Bas 2u1 - 1.64eb862c.jpg";